"use client";
export default function Contact() {
  return (
    <div className="min-h-screen bg-gray-50 py-20 px-8">
      <div className="max-w-4xl mx-auto bg-white p-12 shadow-sm rounded-2xl">
        <h1 className="text-4xl font-black uppercase mb-8">Contact Us</h1>
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <p className="text-gray-600 mb-6">Visit our studio in Muscat for a professional fitting or send us a message.</p>
            <div className="space-y-4">
              <p><strong>Location:</strong> Muttrah, Muscat, Oman</p>
              <p><strong>Phone:</strong> +968 78782020</p>
              <p><strong>Email:</strong> info@alshakilee.com</p>
            </div>
          </div>
          <form className="space-y-4">
            <input type="text" placeholder="Your Name" className="w-full p-4 bg-gray-50 border-none rounded-lg" />
            <textarea placeholder="Message" className="w-full p-4 bg-gray-50 border-none rounded-lg h-32"></textarea>
            <button className="w-full bg-black text-white py-4 font-bold uppercase">Send Message</button>
          </form>
        </div>
      </div>
    </div>
  );
}